'use client';
import React from 'react';
import Link from 'next/link';
import { FolderOpen, ChevronRight, Sparkles } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const EXAMPLE_PROJECTS = [
  { emoji: '☕', title: 'Coffee Shop Startup', dream: 'Launch a local coffee brand', color: 'border-primary/20 bg-primary/5' },
  { emoji: '💍', title: 'Handmade Jewelry Brand', dream: 'Sell artisan jewelry online', color: 'border-accent/20 bg-accent/5' },
  { emoji: '📚', title: "Children\'s Book Series", dream: 'Publish illustrated books', color: 'border-mint/20 bg-mint/5' },
  { emoji: '🎓', title: 'Online Course Business', dream: 'Teach skills and earn online', color: 'border-yellow-400/20 bg-yellow-400/5' },
];

export default function MyProjectsPreview() {
  const { t } = useLanguage();
  const db = t?.dreamBuilder;

  return (
    <section className="py-16 bg-background">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16">
        <div className="flex items-center justify-between mb-8">
          <div>
            <p className="text-xs font-700 uppercase tracking-widest text-primary mb-2">
              {db?.projectSystemLabel ?? 'Project-Based System'}
            </p>
            <h2 className="text-3xl font-800 text-foreground">{db?.myProjectsTitle ?? 'My Projects'}</h2>
            <p className="text-sm text-muted-foreground mt-1">
              {db?.myProjectsSubtitle ?? 'Every dream becomes a saved project. Return and continue where you left off.'}
            </p>
          </div>
          <Link
            href="/my-projects"
            className="flex items-center gap-2 btn-secondary px-4 py-2.5 rounded-xl text-sm font-600 shrink-0"
          >
            <FolderOpen size={15} />
            {db?.viewAll ?? 'View All'}
            <ChevronRight size={14} />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          {EXAMPLE_PROJECTS?.map((proj, i) => (
            <div
              key={`proj-${i}`}
              className={`glass-card rounded-2xl p-5 border ${proj?.color} flex flex-col gap-3`}
            >
              <span className="text-2xl">{proj?.emoji}</span>
              <div>
                <p className="text-sm font-700 text-foreground">{proj?.title}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{proj?.dream}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center">
          <Link
            href="/#dream-input"
            className="flex items-center gap-2 btn-primary px-6 py-3 rounded-xl text-sm font-700"
          >
            <Sparkles size={15} />
            {db?.startNewDream ?? 'Start a New Dream'}
          </Link>
        </div>
      </div>
    </section>
  );
}
